import type { SimpleVehicleProps } from '../types/types'
import { isOutgoingCar } from '../../../../../utils/helpers/helpers.cars'
import { CarStatus } from '../../../../../types'

export function sortCars(cars: SimpleVehicleProps[]) {
  const activeCars = cars.filter((car) => car.status === CarStatus.Active)

  const outgoingSixMonths = cars.filter((car) => isOutgoingCar(car.status, car.plannedReturnDate))

  const closedCars = cars.filter((car) => car.status === CarStatus.Closed)

  const inOrder = cars.filter((car) => car.status === CarStatus.Order)

  return {
    activeCars,
    outgoingSixMonths,
    inOrder,
    closedCars,
  }
}
